var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0067F6",
    d: "M0,1.17613636 C0,0.7245 0.3584,0.357954545 0.8,0.357954545 L9.1,0.357954545 C9.5416,0.357954545 9.9,0.7245 9.9,1.17613636 C9.9,1.62777273 9.5416,1.99431818 9.1,1.99431818 L0.8,1.99431818 C0.3584,1.99431818 0,1.62777273 0,1.17613636 Z M9.1,3.83522727 L0.8,3.83522727 C0.3584,3.83522727 0,4.20177273 0,4.65340909 C0,5.10504545 0.3584,5.47159091 0.8,5.47159091 L9.1,5.47159091 C9.5416,5.47159091 9.9,5.10504545 9.9,4.65340909 C9.9,4.20177273 9.542,3.83522727 9.1,3.83522727 Z M9.1,7.3125 L0.8,7.3125 C0.3584,7.3125 0,7.67904545 0,8.13068182 C0,8.58231818 0.3584,8.94886364 0.8,8.94886364 L9.1,8.94886364 C9.5416,8.94886364 9.9,8.58231818 9.9,8.13068182 C9.9,7.67904545 9.542,7.3125 9.1,7.3125 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.bf9c727cfcf560e08424676e7c3375b7.svg";
export { ForwardRef as ReactComponent };